import http from '../plugins/axios'

export const addPayment = async (payload) => {
  try {
    const response = await http.post(`/api/v2/payments`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updatePayment = async (paymentId, payload) => {
  try {
    const response = await http.put(`/api/v2/payments/${paymentId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deletePayment = async (paymentId) => {
  try {
    const response = await http.delete(`/api/v2/payments/${paymentId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const getPaymentConfirmation = async (params) => {
  try {
    const response = await http.get(`/api/v2/payment-confirmation`, { params })
    return response.data
  } catch (error) {
    throw error  
  }
}

export const updateProofPayment = async (paymentProofId, payload) => {
  try {
    const response = await http.put(`/api/v2/payment-confirmation/${paymentProofId}`, payload)
    return response.data
  } catch (error) {
    throw error  
  }
}

export const getPaymentCountry = async (params) => {
  try {
    const response = await http.get(`/api/v2/country-payments`, { params })
    return response.data
  } catch (error) {
    throw error  
  }
}

export const getDetailPaymentChannel = async (paymentChannelId) => {
  try {
    const response = await http.get(`/api/v2/payment-channels/${paymentChannelId}`,)
    return response.data
  } catch (error) {
    throw error  
  }
}

export const deleteProofPayment = async (paymentId) => {
  try {
    const response = await http.delete(`/api/v2/payment-confirmation/${paymentId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const getListPaymentPlatform = async () => {
  try {
    const response = await http.get(`/api/v2/payment-platforms`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const submitPaymentPlatform = async (payload) => {
  try {
    const response = await http.post(`/api/v2/user-payments`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}